<!--
  ~ Copyright (C) 2025 - Potentially Ltd
  ~
  ~ Please see distribution for license.
  -->

<section class="feedback-question-section">
  <div class="feedback-question-section-top">
    <div class="title-container">
      <ptl-editable-section-title [title]="section?.title" (titleSaved)="saveTitle($event)"> </ptl-editable-section-title>
    </div>
    <ptl-report-top-actions [editIsEnabled]="false" (sectionDelete)="openDialog(section?.uid)">
      <ng-content></ng-content>
    </ptl-report-top-actions>
  </div>

  <mat-card class="feedback-question-section-inner">
    <div class="feedback-question-item headline-item">
      <mat-checkbox
        color="primary"
        [(ngModel)]="allChecked"
        (ngModelChange)="onAllChecked()"
        [attr.aria-label]="
          allChecked
            ? ' ' + ('translations.global.ariaLabels.enabled' | transloco)
            : ' ' + ('translations.global.ariaLabels.disabled' | transloco)
        "
      ></mat-checkbox>

      <div class="number medium">#</div>

      <div class="name medium bold">{{ 'translations.questions' | transloco }}</div>
      <div class="tags medium">{{ 'translations.framework.title.tags' | transloco }}</div>
    </div>
    <div class="feedback-question-item" *ngFor="let item of formattedQuestions; let i = index">
      <mat-checkbox
        color="primary"
        [(ngModel)]="item.included"
        (ngModelChange)="checkIfAllEnabled()"
        [attr.aria-label]="
          item.included
            ? ' ' + ('translations.global.ariaLabels.enabled' | transloco)
            : ' ' + ('translations.global.ariaLabels.disabled' | transloco)
        "
      ></mat-checkbox>

      <div class="number medium">{{ i + 1 }}</div>

      <div class="name medium bold" [innerHTML]="item.question.instruction.value"></div>
      <div class="tags chips-list">
        <span class="chip-item chip-interactive" *ngFor="let tag of item.question.tags">
          {{ tag.title }}
        </span>
      </div>
    </div>

    <div class="feedback-question-action-buttons">
      <button
        mat-flat-button
        class="save-btn"
        color="primary"
        (click)="save()"
        title="{{ 'translations.global.button.saveChanges' | transloco }}"
      >
        {{ 'translations.global.button.saveChanges' | transloco }}
      </button>
    </div>
  </mat-card>
</section>
